import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './LatestArticles.css';
import AuthorNameDecoration from '../AuthorNameDecoration/AuthorNameDecoration';
import config from "../../config";
import { useLanguage } from '../../i18n/LanguageContext';
import { getLocalizedItemLabels } from '../../utils/itemLocaleDisplay';
import { getRootCategories } from '../../utils/categoryTree';
import { getProjectCategory, getProjectApi, getItemListSizeMultiLang, putProjectViewCount } from "../../api";
const LatestArticles = () => {
  const { t, locale } = useLanguage();

  const [data1, setData1] = useState([]);
  const [project, setProject] = useState({});
  const [categoryList, setCategoryList] = useState([]);

  const getAPI = async()=>{


    const res =  getProjectCategory();			
    const res1 =  getProjectApi(config.project.id);		
    const res3 =  getItemListSizeMultiLang(6);
     // const res3 =  getItemSliderList();
 
  
    Promise.all([res,res1,res3]).then((sonuclar)=>{
      //console.log("sonuclar ",sonuclar);
      const cats = sonuclar[0]?.data;
      setCategoryList(getRootCategories(Array.isArray(cats) ? cats : []));
          setData1(sonuclar[2].data);
          setProject(sonuclar[1].data);
          
         
    })
  
      putProjectViewCount({})
  
      }
      useEffect(() => {
        getAPI(); 
      }, [])

  const itemCount = Array.isArray(data1) ? data1.length : 0;
  const cap = (max) => (itemCount === 0 ? 1 : Math.min(max, itemCount));
  const show4 = cap(4);
  const show3 = cap(3);
  const show2 = cap(2);
  /** Az maddeyken (ör. 1) infinite + fazla slidesToShow aynı kartı klonluyor; sadece madde > görünen slayt iken sonsuz kaydır */
  const infiniteScroll = itemCount > show4;

  const settings = {
    dots: false,
    infinite: infiniteScroll,
    speed: 500,
    slidesToShow: show4,
    slidesToScroll: 1,
    arrows: itemCount > 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: show3,
          infinite: itemCount > show3,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: show2,
          infinite: itemCount > show2,
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          infinite: itemCount > 1,
        }
      }
    ]
  };

  return (
    <section className="latest-articles">
      <Container>
        <h2 className="section-title">{t('latest.sectionTitle')}</h2>
        <div className="slider-container">
          <Slider key={itemCount} {...settings}>
            {data1.map((article) => {
              const labels = getLocalizedItemLabels(article, locale);
              return (
              <Link
                key={article.id}
                to={`/article/${article.id}`}
                state={{
                  articleInfo: {
                    title: labels.title,
                    englishTitle: article.englishTitle,
                    author: article.writerName,
                    definition: labels.definition,
                    content: article.content,
                    image: article.primaryImage
                  }
                }}
                className="article-link"
              >
                <div className="latest-article-card">
                  <div className="article-image-container">
                    <img 
                      src={article.primaryImage ? article.primaryImage : '/images/mutfak-logo6.png'} 
                      style={article.primaryImage ?{width: '100%', height: '100%', objectFit: 'cover'} : {width: '100%', height: '100%', objectFit: 'contain'}}
                      alt={labels.title} 
                      className="article-image" 
                    />
                  </div>
                  <div className="article-content">
                    <h3 className="article-title">{labels.title}</h3>
                    <span className="article-english-title">{labels.definition}</span>
                    <div className="article-author">
                      <div className="author-info">
                        <div className="author-frame">
                          <span className="author-name">{article.writerName}</span>
                          <AuthorNameDecoration variant="card" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Link>
            );
            })}
          </Slider>
        </div>
      </Container>
    </section>
  );
};

export default LatestArticles; 